import Portal from './Portal.component';

export default Portal;